import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const COMPANY = {
  name: "AIR-COLD HVAC",
  phone: "(626) 633-6408",
  phoneTel: "+16266336408",
  sms: "sms:+16266336408",
  email: "info@aircoldhvac.com",
  region: "San Gabriel Valley, California",
};

export const SERVICE_AREAS = {
  "San Gabriel Valley": ["Walnut","Diamond Bar","Rowland Heights","Hacienda Heights","West Covina","Covina","La Puente","Baldwin Park","Azusa","Glendora","San Dimas","La Verne","Claremont","Monrovia","Duarte","Pomona"],
  "Inland Empire": ["Chino","Chino Hills","Ontario","Upland","Rancho Cucamonga","Fontana","Eastvale"],
  "North Orange County": ["Brea","Fullerton","Yorba Linda","La Habra","Placentia"],
  "Northeast Los Angeles": ["Eagle Rock","Highland Park","Glassell Park","Atwater Village","Los Feliz","Mount Washington","Silver Lake","Echo Park"],
};

export const BRANDS = [
  "Carrier","Lennox","Goodman","Trane","American Standard","Bryant","Daikin","Rheem","York","Honeywell","Mitsubishi Electric","LG","Midea","Fuji"
];

export const SERVICES = [
  { key: "ac-repair", title: "AC Repair", desc: "Fast diagnostics and same-day fixes to restore comfort.", category: "Cooling" },
  { key: "ac-install", title: "AC Installation", desc: "Premium installs sized to your home with multi-brand options.", category: "Cooling" },
  { key: "ac-replace", title: "AC Replacement", desc: "Upgrade aging systems with efficient new equipment.", category: "Cooling" },
  { key: "ac-maintain", title: "AC Maintenance", desc: "Seasonal tune-ups that extend life and lower bills.", category: "Cooling" },
  { key: "furnace-repair", title: "Furnace Repair", desc: "Heating restored quickly — gas, electric, or heat pump.", category: "Heating" },
  { key: "furnace-install", title: "Furnace Installation", desc: "Modern furnace installs with quiet, efficient operation.", category: "Heating" },
  { key: "heating-maintain", title: "Heating Maintenance", desc: "Pre-season checks for safety, efficiency, and reliability.", category: "Heating" },
  { key: "heat-pump", title: "Heat Pumps", desc: "All-in-one heating + cooling that pays you back.", category: "Systems" },
  { key: "mini-split", title: "Mini Split Systems", desc: "Ductless comfort for additions, garages, and zoning.", category: "Systems" },
  { key: "thermostat", title: "Thermostat Installation", desc: "Smart thermostats, zoning, and pro setup.", category: "Systems" },
  { key: "iaq", title: "Indoor Air Quality", desc: "Filtration, UV, and purification — breathe better.", category: "Comfort" },
  { key: "ducts", title: "Air Duct Services", desc: "Sealing, repair, and replacement for full-system gains.", category: "Comfort" },
  { key: "commercial", title: "Commercial HVAC", desc: "Rooftops, package units, and split systems for business.", category: "Commercial" },
  { key: "emergency", title: "Emergency HVAC", desc: "24/7 response when comfort can't wait.", category: "Emergency" },
];
